var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDisplay())?_c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"fixed-button"},[_c('a',{attrs:{"href":_vm.facilityDetail.facility.url,"target":"_blank"},on:{"click":function($event){return _vm.handleAnalyticsTrackEvent(
          'facility_detail',
          'click',
          'official_link',
          1
        )}}},[_vm._v("\n      "+_vm._s(_vm.name)+"\n    ")])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }